import React from 'react'
// import MDBox from 'components/MDBox'
import FilterCard from './components/FilterCard'
import GroupTable from './components/Table'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
function VehicleGroup() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <FilterCard/>
       <GroupTable/>
    </DashboardLayout>
   
  )
}

export default VehicleGroup
